/**
 * Exchange Metadata — canonical mapping of African exchange codes to their
 * full official names with preserved diacritical marks and native scripts.
 *
 * Format: [SYMBOL] -> { code, name, nameShort, region, currency }
 * UTF-8 encoding is enforced across all component templates.
 */

const EXCHANGE_METADATA = {
  NSE:   { code: "NSE",   name: "Nairobi Securities Exchange",                              region: "Kenya",          currency: "KES" },
  NGX:   { code: "NGX",   name: "Nigerian Exchange Group",                                  region: "Nigeria",        currency: "NGN" },
  JSE:   { code: "JSE",   name: "Johannesburg Stock Exchange",                              region: "South Africa",   currency: "ZAR" },
  EGX:   { code: "EGX",   name: "Egyptian Exchange (\u0627\u0644\u0628\u0648\u0631\u0635\u0629 \u0627\u0644\u0645\u0635\u0631\u064A\u0629)", region: "Egypt", currency: "EGP" },
  BRVM:  { code: "BRVM",  name: "Bourse R\u00E9gionale des Valeurs Mobili\u00E8res",        region: "West Africa",    currency: "XOF" },
  BVMAC: { code: "BVMAC", name: "Bourse des Valeurs Mobili\u00E8res d\u2019Afrique Centrale", region: "Central Africa", currency: "XAF" },
  SEM:   { code: "SEM",   name: "Stock Exchange of Mauritius",                              region: "Mauritius",      currency: "MUR" },
  BCVM:  { code: "BCVM",  name: "Bolsa de Valores e Mercadorias de Mo\u00E7ambique",        region: "Mozambique",     currency: "MZN" },
  GSE:   { code: "GSE",   name: "Ghana Stock Exchange",                                    region: "Ghana",          currency: "GHS" },
  ZSE:   { code: "ZSE",   name: "Zimbabwe Stock Exchange",                                 region: "Zimbabwe",       currency: "ZWL" },
  BSE:   { code: "BSE",   name: "Botswana Stock Exchange",                                 region: "Botswana",       currency: "BWP" },
  DSE:   { code: "DSE",   name: "Dar es Salaam Stock Exchange",                            region: "Tanzania",       currency: "TZS" },
  USE:   { code: "USE",   name: "Uganda Securities Exchange",                              region: "Uganda",         currency: "UGX" },
  RSE:   { code: "RSE",   name: "Rwanda Stock Exchange",                                   region: "Rwanda",         currency: "RWF" },
  LuSE:  { code: "LuSE",  name: "Lusaka Securities Exchange",                              region: "Zambia",         currency: "ZMW" },
  CASE:  { code: "CASE",  name: "Cairo and Alexandria Stock Exchange",                      region: "Egypt",          currency: "EGP" },
  NSX:   { code: "NSX",   name: "Namibian Stock Exchange",                                 region: "Namibia",        currency: "NAD" },
  SZSE:  { code: "SZSE",  name: "Eswatini Stock Exchange",                                 region: "Eswatini",       currency: "SZL" },
  EAX:   { code: "EAX",   name: "East Africa Exchange",                                    region: "East Africa",    currency: "USD" },
  ESE:   { code: "ESE",   name: "Ethiopian Securities Exchange",                           region: "Ethiopia",       currency: "ETB" },
};

/**
 * Get the full localized label for an exchange code.
 * Returns "[CODE] - [FULL NAME]" or the code itself if unknown.
 * @param {string} code — exchange code (e.g., "BRVM")
 * @returns {string}
 */
export function getExchangeLabel(code) {
  const upper = (code || "").toUpperCase();
  const meta = EXCHANGE_METADATA[upper];
  if (meta) return `${meta.code} \u2013 ${meta.name}`;
  return code || "OTHER";
}

/**
 * Get exchange metadata object, or null if unknown.
 * @param {string} code
 * @returns {{ code: string, name: string, region: string, currency: string } | null}
 */
export function getExchangeMeta(code) {
  return EXCHANGE_METADATA[(code || "").toUpperCase()] || null;
}

export default EXCHANGE_METADATA;
